import styled from 'styled-components'

import { color, fontFamily } from '../../styles'

import { fontSize, fontWeight } from 'src/styles/fonts'
import { media } from 'src/styles/media'

export const Wrap = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${color.WHITE};
  border-radius: 1.6rem;
  padding: 8.8rem 4.8rem 5.6rem;

  ${media.desktop} {
    width: 48rem;
  }
`

export const StyledForm = styled.form`
  position: relative;
  display: flex;
  flex-direction: column;
  margin: 3.2rem 0 8rem 0;
  max-width: 48rem;
  width: 100%;

  label {
    margin-bottom: 0.8rem;
  }

  button {
    align-self: center;
    margin-top: 8rem;
  }
`

export const StyledInput = styled.input`
  width: 100%;
  height: 4.8rem;
  border-radius: 0.6rem;
  background-color: ${color.VERY_LIGHT_PINK};
  border: none;
  padding-left: 1.6rem;
  margin-bottom: 1.6rem;
  font-size: ${fontSize.NORMAL};
  line-height: 4.8rem;
  color: ${color.GREYISH_BROWN};
  font-family: ${fontFamily.CATAMARAN};

  ::placeholder {
    font-size: ${fontSize.NORMAL};
    color: ${color.PUTTY};
  }
`

type SelectedButtonProps = {
  isActive: boolean
}

export const SelectButton = styled.div<SelectedButtonProps>`
  display: flex;
  align-items: center;
  width: 100%;
  height: 4.8rem;
  padding-left: 1.6rem;
  line-height: 1.5;
  font-size: ${fontSize.NORMAL};
  font-family: ${fontFamily.CATAMARAN};
  background-color: ${color.WHITE};
  color: ${({ isActive }) =>
    isActive ? `${color.DUSTY_ORANGE}` : `${color.GREYISH_BROWN}`};
  font-weight: ${fontWeight.MEDIUM};
  border-bottom: 0.1rem solid ${color.VERY_LIGHT_PINK};
`

export const LocateButton = styled.button`
  font-family: ${fontFamily.CATAMARAN};
  font-size: ${fontSize.NORMAL};
  color: ${color.DULL_ORANGE};
  margin-top: 1.6rem;
`
